// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2J5sS","dragIcon":"Choice_dragIcon__2i2XO","left":"Choice_left__1zYEv","input":"Choice_input__2fZ1e"};